
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPushButtonOn as ObiPushButtonOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-push-button-on.js';
 
 
 

 
 export const ObiPushButtonOn = createComponent({
   react: React,
   tagName: 'obi-push-button-on',
   elementClass: ObiPushButtonOnElement,
   events: {
     
   }
  });
 
 